// @ts-nocheck
import { Plugin } from '/builds/cloud-collaboration-front/ncc-front/popo-front/popo-meeting-frontend/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
